import { IReportingTypeService } from "../../service/reporting/ReportingTypeService";
import { IReportingType } from "../../model/reporting/ReportingType";

export default class CreateReportingTypeInteractor {
  private reportingTypeService: IReportingTypeService;

  constructor(reportingTypeService) {
    this.reportingTypeService = reportingTypeService;
  }

  async execute(reporting: IReportingType) {
    return this.reportingTypeService.createReportingType(reporting);
  }
}
